import api from '@/api/axiosApi'

export async function downloadTemplate(): Promise<void> {
  const response = await api.get('/product-lists/template', {
    params: { type: 'sourcing' },
    responseType: 'blob',
  })

  // Create blob URL and trigger download
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'sourcing_import_template.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
